module.exports = __webpack_public_path__ + "static/img/xiaopeng.a58713a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/xiaopeng.jpg
// module id = mTPA
// module chunks = 0